import {
    POST,
    GET
} from "../util";

const operationUrl = "api/sell-operation";
const inspectionUrl = "api/sell-inspection";

const url = {
    inspection: {
        listApproved: `${inspectionUrl}/list-approved`,
        listSelling: `${inspectionUrl}/list-selling`,
    },

    operation: {
        startAuction: `${operationUrl}/start-auction`,
        sellWithOption: `${operationUrl}/sell-with-option/:receivableId/:optionId`,
    }
};


const sellApi = {
    inspection: {
        listApproved: (params = {}) => {
            return POST(url.inspection.listApproved, params);
        },
        listSelling: (params = {}) => {
            return POST(url.inspection.listSelling, params);
        }
    },

    operation: {
        startAuction: (params = {}) => {
            return POST(url.operation.startAuction, params, "application/json", 'Array');
        },
        sellWithOption(receivableId, optionId) {
            return POST(url.operation.sellWithOption.replace(":receivableId", receivableId).replace(":optionId", optionId));
        },
    }
};

export {
    sellApi
};